import "core-js/modules/es6.string.link";
import "core-js/modules/es6.typed.uint8-array";
import "core-js/modules/es6.regexp.match";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.function.name";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import result from "./result";
import { updateComponent, putFile } from '@/api/visual/visual'; // import {putFile} from '@/api/visual/visual'

export default {
  inject: ["contain"],
  components: {
    result: result
  },
  methods: {
    handleReset: function handleReset() {
      this.contain.menuFlag = true;
      this.contain.setScale(this.contain.contentWidth);
    },
    handleFlag: function handleFlag(name) {
      var _this = this;

      console.log('name', name);
      console.log('this.contain', this.contain);
      this.contain[name] = !this.contain[name];
      this.$nextTick(function () {
        _this.contain.setScale(document.getElementsByClassName('section')[0].clientWidth);
      });
    },
    handleView: function handleView() {
      var _this2 = this;

      this.contain.menuFlag = false;
      this.$nextTick(function () {
        _this2.contain.handleInitActive();

        _this2.contain.setScale(document.body.clientWidth);
      });
    },
    handleBuild: function handleBuild(fn) {
      var _this3 = this;

      var isFun = typeof fn === 'function';

      if (!isFun && this.$route.params.id <= 100 && this.$website.isDemo) {
        this.$message.error(this.$website.isDemoTip);
        return;
      }

      this.contain.handleInitActive();
      var loading = this.$loading({
        lock: true,
        text: '正在保存配置，请稍后',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.$nextTick(function () {
        html2canvas(document.getElementById('content'), {
          useCORS: true,
          backgroundColor: null,
          allowTaint: true
        }).then(function (canvas) {
          function dataURLtoFile(dataurl, filename) {
            var arr = dataurl.split(','),
                mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]),
                n = bstr.length,
                u8arr = new Uint8Array(n);

            while (n--) {
              u8arr[n] = bstr.charCodeAt(n);
            }

            return new File([u8arr], filename, {
              type: mime
            });
          }

          var file = dataURLtoFile(canvas.toDataURL('image/jpeg', 0.1), new Date().getTime() + '.jpg');
          var formdata = new FormData();
          formdata.append('file', file);
          putFile(formdata).then(function (res) {
            var data = res.result;
            var url = data.link;
            var formdata = {
              visual: {
                id: _this3.contain.visual.id,
                backgroundUrl: url
              },
              config: {
                id: _this3.contain.obj.config.id,
                visualId: _this3.contain.visual.id,
                detail: JSON.stringify(_this3.contain.config),
                component: JSON.stringify(_this3.contain.nav)
              }
            };
            return updateComponent(formdata);
          }).then(function () {
            loading.close();

            if (isFun) {
              fn();
            } else {
              _this3.$message.success('大屏配置保存成功');
            }
          }).catch(function (err) {
            console.log(err);

            _this3.$message.error('大屏配置保存失败，请检查服务端配置');

            loading.close();
          });
        });
      });
    },
    handleImg: function handleImg() {
      var _this4 = this;

      this.$confirm({
        title: '提示',
        content: '是否导出大屏图片',
        onOk: function onOk() {
          _this4.$Screenshot(document.querySelector("#wrapper")).then(function (canvas) {
            _this4.downFile(canvas.toDataURL("image/jpeg", 0.8), new Date().getTime());

            _this4.$message.success('图片导出成功');
          });
        }
      });
    },
    handleShare: function handleShare() {
      var _this5 = this;

      this.handleBuild(function () {
        var routeUrl = _this5.$router.resolve({
          path: '/visualPreview/' + _this5.contain.id
        });

        window.open(routeUrl.href, '_blank');
      });
    }
  }
};